import { ModalManager } from "../managers/ModalManager";
import { SendData } from "./SendData";

/**
 * @param {HTMLElement} elem 
 * @param {int} m_prod_id int
 */
export function doDeleteM_prod({ elem, m_prod_id }) {
  if (!confirm('Вы уверены, что хотите отозвать заявку?')) return;
  new SendData({
    data: {
      m_prod_id: m_prod_id
    },
    messageAuto: true,
    url: window.Redirect.route('doDeleteM_prod')
  }).then(response => {
    elem.reload();
  })
}
/**
 * @param {HTMLElement} elem 
 * @param {int} m_prod_id int
 */
export function doNewOrder({ elem, m_prod_id }) {
  new ModalManager({
    data: {
      m_prod_id: m_prod_id
    },
    url: Redirect.route('upsertOrderModal')
  }).open().then(() => {
    elem.reload();
  })
}
/**
 * 
 * @param {*} param0 
 */
export function openOrderModal({ elem }) {
  new ModalManager({
    elem,
    url: Redirect.route('upsertOrderModal')
  }).open().then(() => elem.reloadGlobal());
}